export default {
  // 业务工作流
  businessFlow: {
    bussinessFlowInof: '业务流程信息',
    flowStatus: '流程状态',
    status: '状态',
    beginTime: '发起时间',
    creater: '创建人',
    bussinessFlowPic: '业务流程图',
    flowRecord: '流程记录',
    completeTask: '完成了任务',
    HhaveInHand: '进行中',
    yistop: '已终止',
    yicompleted: '已完成',
    yidelete: '已删除',
    agreeOrDisagree: '同意/不同意',
    businessFlow: '业务流程',
    businessFlowInfo1: '流程信息',
    approvalPass: '审批通过',
    approvalReject: '审批驳回',
    approvaling: '审批中',
    approvalResult: '审批结果',
    taskUpdatePer: '此任务需要变更负责人',
    taskAddOrReferenceData: '此任务需要新增或关联数据',
    taskAddData: '此任务需要新增数据',
    agree: '同意',
    disagree: '不同意',
    inputContent: '填写意见',
    completedTask: '完成任务',
    completeTaskBefore: '完成此任务前需要为下一个任务选择执行人',
    auth: '权限',
    selectPerOverPer: '所选人员覆盖下一任务预置执行人',
    selectperAdd: '所选人员添加到下一任务的执行人中',
    handlePer: '处理人',
    selectExecutor: '请选择执行人',
    changeExecutor: '更换执行人成功',
    selectLeader: '请选择负责人',
    selectNextTaskExecutor: '请选择下一任务执行人',
    guanlianDataSUccess: '关联数据成功',
    updateLeaderSuccess: '变更负责人成功',
    approvalSuccess: '审批完成',
    input: '填写',
    updataLeader: '变更负责人',
    resetBussinessflow: '重置业务流程完成',
    stopBussinessflow: '终止业务流程完成',
    startBussinessflow: '重启业务流程完成',
    changeHandlePer: '更换执行人',
    reset: '重置',
    currentVersion: '当前版本',
    LatestVedition: '最新版本',
    stop: '终止',
    enable: '启用',
    temporaryStorage: '暂存',
    saveAndEnable: '保存并启用',
    businessNode: '业务节点',
    baseNode: '基础节点',
    start: '开始',
    flowColor: '流程颜色',
    selectColor: '选择颜色',
    customColor: '自定义颜色',
    color: '颜色',
    addStage: '添加阶段',
    businessName: '业务名称',
    gouxuan1: '勾选则代表前置所有节点分支都完成后才创建当前业务活动',
    gouxuan2: '不勾反之，后续业务活动会存在多个处理',
    beforeCompleteTask: '再前置节点都完成后才能生成当前业务活动',
    describe: '描述',
    befroreTaskChooseOne: '对前置业务活动中的哪一条数据执行操作',
    executionOperation: '执行操作',
    guanlianModule: '关联模块',
    yunxuAdd: '只允许新建不能关联已有数据',
    oprationContent: '操作内容',
    oprationBtnName: '操作按钮名称',
    approvalBusinessData: '审批业务数据',
    selectApprovaler: '选择审批人',
    nodeCompleteNextPer: '节点完成时，执行人可指定下一节点执行人',
    approvalContent: '审批内容',
    editFields: '编辑字段',
    addField: '添加字段',
    businessExecutor: '该业务执行人',
    approvalCondition: '审批条件',
    afterIn: '后进入',
    stageStopTime: '阶段停留时间',
    stopTingliu: '限制停留',
    afterChaoshi: '后超时',
    chaoshiRemind: '超时提醒',
    afterRemind: '后提醒',
    remindPer: '提醒人员',
    addRemind: '添加提醒',
    nodeBreanchJudage: '节点分支判断',
    condtionIn: '满足条件进入',
    addBrenchCondition: '添加分支条件',
    notInCondition: '不满足以上条件进入',
    stage: '阶段',
    stageName: '阶段名称',
    proventNodeData: '上一个节点的数据',
    beforeChaoshi: '超时前',
    afterChaoshi1: '超时后',
    completeAfter: '完成后',
    addOrGuanlianData: '新建或关联模块数据',
    judge1: '请优先选择对前置业务活动中的哪一条数据执行操作',
    judge2: '该节点缺少一条连入的线',
    judge3: '节点未选择前置业务数据',
    oneStage: '第一阶段',
    businessHuodong: '业务活动',
    end: '结束',
    di: '第',
    dontDelStartNode: '不能删除开始节点',
    initNodeDontDel: '初始化的阶段不能删除',
    approvalNode: '审批节点',
    breanchNode: '分支节点',
    judge4: '该节点有且只能有两根连出的线',
    judge5: '阶段名称必填',
    judge6: '至少有一个业务活动节点',
    judge7: '至少有一个结束节点',
    judge8: '不能为空',
    judge9: '节点，必须在阶段内',
    judge10: '节点，两个相同的节点之间不能有超过一条以上的连接线',
    judge11: '【开始】节点，有且只有一条连出的线',
    judge12: '节点，至少有一条连入的线',
    judge13: '节点，至少有一条连出的线',
    judge14: '【结束】节点，至少有一条连入的线',
    judge15: '节点，有且只有一条连入的线',
    judge16: '节点，有且只有两条连出的线',
    judge17: '节点，至少有两条连出的线',
    judge18: '分支节点之间不能直接连接',
    judge19: '节点名称必填',
    judge20: '节点，未选择对前置业务活动中的哪一条数据执行操作',
    judge21: '节点，关联模块必填',
    judge22: '节点，至少选择一个编辑字段',
    judge23: '节点，操作按钮名称必填',
    judge24: '节点，业务执行人必填',
    judge25: '节点，审批人必填',
    judge26: '节点，审批条件有误',
    judge27: '节点，分支判断有误',
    judge28: '节点，请选择不满足以上条件进入的节点',
    currentProcess: '当前流程',
    resetRecord: '重置记录',
    resetList: '重置列表',
    processName: '流程名称',
    completionTime: '完成时间',
    gouxuan3: '勾选后后置节点不允许返回连接当前节点及之前节点',
    gouxuan4: '在前置节点都完成后才能生成当前业务活动',
    beforBusinessOpertion: '对前置业务活动中的哪一个节点执行操作',
    moreZhixMemberInfo: '多个执行人处理方式',
    approval: '审批',
    delBusinessFolw: '确定要删除业务流程吗?',
    yingxiangInfo1: '当前操作将影响',
    yingxiangInfo2: '设置将被清空，需重新去设置，确定要操作吗?',
    pleaseChooseOp: '请选择执行操作',
    qianzhi: '前置',
    zhixingUp: '执行人上级',
    newJiedduan: '新阶段',
    judge29: '勾选了前置完成，不允许后置节点返回当前节点及之前节点',
    judge30: '不允许连接到',
    judge31: '该场景暂不支持',
    judge32: '节点错误配置，不允许连接结束又连接其他节点',
    judge33: '节点配置错误，请正确连接',
    judge34: '分支错误配置，不允许',
    judge35: '连接结束又',
    judge36: '连接其他业务节点',
    judge37: '分支错误配置，不允许连接结束节点的条件和连接其他节点条件相同',

    // 2020-12-28
    submitBusinessForyouHandle: '提交的业务流程需要您处理',
    stageNameCustomComponent: '阶段名称赋值至自定义组件',
    customComponentStageName: '字段组件赋值阶段名称',
    passRemark: '通过意见',
    rejectRemark: '驳回意见',
    viewApprovalData: '查看审批数据',
    dataCreatedAwaitingApproval: '数据已新建提交，等待审批中...',
    dataBeenRejectedCreated: '数据被"审批驳回"，请重新创建数据或查看审批数据。',
    showFillingInstructions: '操作中显示填写说明',
    currentModuleHasApprovalFlow: '当前模块存在审批流程，审批通过后节点才算已完成',
    pendingApprovalUp: '待审批递补，若上级空缺系统自动向上递补',
    emailsSenderPass: '发件人的邮件地址必须是验证通过的，若未绑定验证通过则邮件不会发送',
    processAdvice: '流程意见',
    maxLength500: '最大输入500个文字'
  }
}
